<!-- 组件说明 -->
<!--type 1双流妇幼2019版 2双流妇幼2020版 3彭州妇幼2020版 5郫都妇幼2021宫颈版 6郫都妇幼2021两癌版 7温江妇幼2021版 8南山医疗集团2021版-->
<template>
  <div class="wrap">
    <Header title="知识问卷" />
    <div class="a1">
      <h2>
        {{ title }}
      </h2>

      <div class="con">
        <van-form
          @submit="onSubmit"
          :scroll-to-error="true"
          :validate-first="true"
        >
          <div
            v-for="(item,index) in content"
            :key="index"
          >
            <p>{{ index + 1 }}、{{ item.title }}</p>
            <!-- 单选 -->
            <van-field
              v-if="item.type === '1'"
              :name="`wenjuan_aswer${index + 1}`"
              :rules="[{ required: item.required, message: '必填项' }]"
            >
              <template #input>
                <van-radio-group v-model="form[`wenjuan_aswer${index + 1}`]">
                  <van-radio
                    v-for="(q,i) in item.list"
                    :key="i"
                    :name="q.split('@@@')[0]"
                  >
                    {{ q.split('@@@')[0] }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <!-- 多选 -->
            <van-field
              v-if="item.type === '2'"
              :name="`wenjuan_aswer${index + 1}`"
              :rules="[{ required: item.required, message: '必填项' }]"
            >
              <template #input>
                <van-checkbox-group v-model="form[`wenjuan_aswer${index + 1}`]">
                  <van-checkbox
                    v-for="(q,i) in item.list"
                    :key="i"
                    :name="q.split('@@@')[0]"
                    shape="square"
                  >
                    {{ q.split('@@@')[0] }}
                  </van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>
            <!-- 文本 -->
            <van-field
              v-if="item.type === '3'"
              :name="`wenjuan_aswer${index + 1}`"
              :rules="[{ required: item.required, message: '必填项' }]"
              v-model="form[`wenjuan_aswer${index + 1}`]"
              :placeholder="item.list[0]"
            />
          </div>
          <div class="btns">
            <van-button
              @click="$router.go(-1)"
              block
              round
            >
              上一步
            </van-button>
            <van-button
              v-if="questionnaire && questionnaire === '9'"
              round
              block
              plain
              type="info"
              native-type="button"
              @click="submit1"
            >
              跳过
            </van-button>
            <van-button
              round
              block
              type="info"
              native-type="submit"
            >
              下一步
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/header'
import { Button, Checkbox, CheckboxGroup, Field, Form, Radio, RadioGroup, Toast } from 'vant'

export default {
  components: {
    Header,
    [Form.name]: Form,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Toast.name]: Toast
  },
  data () {
    return {
      templateId: '',
      id: '',
      insId: '',
      form: {},
      txt: '',
      insData: {},
      userData: {},
      title: '',
      content: '',
      /*
      * questionnaire 问卷调查
      * 读取JSON.parse(localStorage.insData).limitCondition的值
      * tyoe: []
      * 不包括 9，没有知识问卷 questionnaire = ''
      * 包括 9, 知识问卷选填 questionnaire = '9'
      * 包括 c, 知识问卷必填 questionnaire = 'c'
      */
      questionnaire: ''
    }
  },
  async mounted () {
    const insData = JSON.parse(localStorage.getItem('insData'))
    const userData = JSON.parse(localStorage.getItem('userData'))
    this.templateId = insData.questionnaireTemplateId.split(',')[insData.type - 1]
    this.insData = insData
    this.userData = userData
    // 根据机构设置判断知识问卷是否必填
    if (JSON.parse(localStorage.insData).limitCondition.includes(9)) {
      this.questionnaire = '9'
    } else if (JSON.parse(localStorage.insData).limitCondition.includes('c')) {
      this.questionnaire = 'c'
    } else {
      this.questionnaire = ''
    }
    this.id = userData.id
    this.insId = userData.insId
    this.insData = JSON.parse(localStorage.insData)
    this.getTemplate()
  },
  methods: {
    async getTemplate () {
      const { data } = await this.$api.personal.getTemplateInfo({
        id: this.templateId
      })
      this.title = data.title
      this.content = JSON.parse(data.templateContent)
      this.setDefault()
    },
    setDefault () {
      const d = this.content

      d.forEach((v, index) => {
        if (v.type === '1' || v.type === '2') {
          this.$set(this.form, `wenjuan_aswer${index + 1}`, v.type === '2' ? [] : '')

          v.list.forEach(m => {
            if (m.split('@@@')[1]) {
              if (v.type === '2') {
                this.form[`wenjuan_aswer${index + 1}`].push(m.split('@@@')[0])
              } else {
                this.form[`wenjuan_aswer${index + 1}`] = m.split('@@@')[0]
              }
            }
          })
        }
      })
    },
    onSubmit (values) {
      // 处理非必填单选题=>没有填写的情况下，值为undefined,需要改成空字符串
      Object.keys(values).map(key => {
        if (values[key] === undefined) {
          values[key] = ''
        }
      })
      // 保存知识问卷模板id与填写答案
      const questionAnswer = { templateId: this.templateId, ...values }
      localStorage.setItem('questionAnswer', JSON.stringify(questionAnswer))
      this.$router.push('/agreement')
    },
    submit1 () {
      localStorage.removeItem('questionAnswer')
      this.$router.push('/agreement')
    }
  }
}
</script>

<style scoped lang="less">
/* @import url() */
.wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.a1 {
  flex: 1;
  overflow-y: auto;
  padding: 0.2rem;

  h2 {
    font-size: 0.3rem;
    text-align: center;
    padding-bottom: 0.3rem;

    &:first-child {
      padding: 0.3rem 0 0.2rem;
    }
  }

  p {
    font-size: 0.3rem;
    line-height: 0.5rem;
    margin: 0.2rem 0;
  }

  .van-cell:not(:last-child)::after {
    display: none;
  }

  .con {
    .van-radio,
    .van-checkbox {
      margin-bottom: 0.2rem;
    }

    .van-cell {
      padding: 0;
    }

    .btns {
      display: flex;

      .van-button {
        margin-top: 0.4rem;
        margin-right: 0.1rem;
      }
    }
  }
}
</style>
